import * as buildingInventoryActions from '../actions/building-inventory.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { update } from '../crud-functions';

export interface BuildingInventoryState {
  buildingInventory: any;
  loading: boolean;
  loaded: boolean;
  updateSuccess: boolean;
  error: string;
}

const initialState = {
  buildingInventory: null,
  loading: false,
  loaded: false,
  updateSuccess: null,
  error: null
};

export const buildingInventoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case buildingInventoryActions.GET_BUILDING_INVENTORY_LIST:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false
      };
    case buildingInventoryActions.GET_BUILDING_INVENTORY_LIST_SUCCESS:
      return {
        ...state,
        error: null,
        buildingInventory: action.payload,
        loading: false,
        loaded: true,
      };
    case buildingInventoryActions.GET_BUILDING_INVENTORY_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: false
      };
    case buildingInventoryActions.CLEAR_BUILDING_INVENTORY_LIST:
      return {
        ...state,
        error: null,
        buildingInventory: null,
        loading: false,
        loaded: false
      };

    case buildingInventoryActions.UPDATE_INSURANCE_APPROACH_SUCCESS:
      const inv = action.payload;
      const buildingInventories = update(state.buildingInventory, inv, 'id');

      return {
        ...state,
        error: null,
        buildingInventory: buildingInventories,
        loading: state.loading,
        loaded: state.loaded,
        updateSuccess: true
      };
    case buildingInventoryActions.UPDATE_INSURANCE_APPROACH_FAIL:
      return {
        ...state,
        error: action.payload,
        updateSuccess: false
      };
    case buildingInventoryActions.RESET_BUILDING_INVENTORY_CRUD:
      return {
        ...state,
        error: null,
        updateSuccess: null
      };
    default:
      return state;
  }
};

export const getBuildingInventoryState = createFeatureSelector<BuildingInventoryState>('buildingInventoryReducer');

export const getBuildingInventoryList = (state: BuildingInventoryState) => state.buildingInventory;
export const getActiveBuildingInventoryList = (state: BuildingInventoryState) =>
  !state.buildingInventory ?
    null :
    state.buildingInventory.filter(x => x.isInsurance === true);
export const getBuildingInventoryListLoaded = (state: BuildingInventoryState) => state.loaded;
export const getBuildingInventoryUpdateStatus = (state: BuildingInventoryState) => state.updateSuccess;
export const getUnassignedBuildingCount = (state: BuildingInventoryState) =>
  state.buildingInventory ?
    state.buildingInventory.filter(x => !x.bGroupId && x.isInsurance).length :
    0;
